var _image;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 14
  }, props), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 26,
    height: 14,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAOCAYAAAAxDQxDAAAABHNCSVQICAgIfAhkiAAAAdJJREFUOE+NlE0oRUEUx70iYSUlsUGxYSFfZaOnJBZEWVmIUj6yIwsb9UJZWCCRFVlQvlZs5GtJ+UhSNmIhSiELinh+f83VuO59z6lf98w5Z+bMPXNmAuFwOOYfEk9MKRRBAaTAPRzDIezDR6R1AlES5TK5HeohO8JCF/jWYBquveL8EmUSPAAt1qQb9F5YtGxd6IOQbGyffGcgBLd2Qq9EnQSMQ6wVuIVeacZB83d3fDcgEXahxIp/Qdcm5hybnSgO4zLU2TtBfzI7TuB7ZpIo5AjK4A3k05klueYuMG6SzUmUhr4HOhO36A9V+0vIspyF6GoGR4ZQ+j3mn2ALKlE5yhKkegTJpI7LMInskEYGK5YhiL7js8aVEk3iVD39JICjArZdATqjWjiHV8iHU99FSKQdqzQtPkGZ2B/g2cev+6PzLYYDn5gJuxlGCOrzCJzF1gpT0OHhV0W6YRUaPPy6JiF3ezebBdWytmi3egGGTTLdG3XZGKgJvEr7iL3NbOCn6+xF0xmolKq/I+8oNaD75Ba9GnoVbFFz6e9V8m+J9ARV4+8B56IqXu08D1eQA6pAnpVhHX0U/nRftLdOa+gxVe2rQHfHLXpQN0FnZN+rX3Ffk5p8ZOTO1NIAAAAASUVORK5CYII="
  })));
};

export default SvgEye;